import React, { useState } from 'react';
import { Box, TextField, Button, Paper } from '@mui/material';

const generateToken = (password) => {
  const time = new Date().getTime();
  return btoa(`${password}_${time}`); // 간단한 암호화
};

const PasswordAuth = ({ onAuth }) => {
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === process.env.REACT_APP_AUTH_PASSWORD) {
      const token = generateToken(password);
      localStorage.setItem('auth_token', token);
      onAuth(true);
    }
  };

  return (
    <Box sx={{ 
      height: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center' 
    }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <form onSubmit={handleSubmit}>
          <TextField
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="비밀번호를 입력하세요"
            fullWidth
            margin="normal"
          />
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            입력
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default PasswordAuth;
